import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Mail, MapPin, Scale } from 'lucide-react';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0d1117] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back button */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#8b949e] hover:text-[#ff6b00] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Назад на маркет</span>
        </Link>

        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-8 h-8 text-[#ff6b00]" />
          <h1 className="text-3xl font-bold text-white">Публичная оферта</h1>
        </div>

        {/* Legal entity info */}
        <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-6 mb-8">
          <h2 className="text-lg font-semibold text-white mb-4">Продавец</h2>
          <div className="space-y-2 text-[#8b949e]">
            <p><span className="text-[#c9d1d9]">Наименование:</span> MEGA PANDA, LLC</p>
            <p><span className="text-[#c9d1d9]">Регистрационный номер (NCR):</span> 0000999047</p>
            <p><span className="text-[#c9d1d9]">Юридический адрес:</span> UL. BOHATERÓW MONTE CASSINO 39-14, PL-81-767, SOPOT, POLAND</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none">
          <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-6 space-y-6">
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Термины и определения</h2>
              <p className="text-[#8b949e] leading-relaxed mb-2">
                В настоящей оферте используются следующие термины:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li><strong className="text-[#c9d1d9]">Продавец</strong> — MEGA PANDA, LLC, юридическое лицо, осуществляющее продажу цифровых товаров.</li>
                <li><strong className="text-[#c9d1d9]">Покупатель</strong> — физическое лицо, имеющее намерение приобрести или приобретающее цифровые товары исключительно для личных нужд.</li>
                <li><strong className="text-[#c9d1d9]">Сайт</strong> — интернет-ресурс Xpanda Market, расположенный по адресу market.xpanda.pro.</li>
                <li><strong className="text-[#c9d1d9]">Цифровой товар</strong> — виртуальные предметы (скины) для игры Counter-Strike 2, являющиеся цифровым контентом.</li>
                <li><strong className="text-[#c9d1d9]">Steam</strong> — платформа цифрового распространения компьютерных игр и программного обеспечения компании Valve Corporation.</li>
                <li><strong className="text-[#c9d1d9]">Trade URL</strong> — уникальная ссылка для обмена предметами в системе Steam.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. Общие положения</h2>
              <p className="text-[#8b949e] leading-relaxed">
                2.1. Настоящий документ является публичной офертой (предложением) MEGA PANDA, LLC 
                заключить договор купли-продажи цифровых товаров на условиях, изложенных в настоящей оферте.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                2.2. Акцептом оферты (заключением договора) является совершение Покупателем действий, 
                направленных на приобретение цифрового товара: добавление товара в корзину, 
                оплата товара, принятие условий настоящей оферты.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                2.3. Оферта действует бессрочно до момента её отзыва Продавцом.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                2.4. Продавец оставляет за собой право вносить изменения в условия оферты. 
                Изменения вступают в силу с момента их публикации на Сайте.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Предмет договора</h2>
              <p className="text-[#8b949e] leading-relaxed">
                3.1. Продавец обязуется передать в собственность Покупателя цифровые товары 
                (виртуальные предметы для игры Counter-Strike 2), а Покупатель обязуется 
                принять и оплатить эти товары на условиях настоящей оферты.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                3.2. Цифровые товары являются виртуальными объектами, существующими только 
                в рамках платформы Steam, и не имеют материальной формы.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                3.3. Продавец не является правообладателем игры Counter-Strike 2 и связанных 
                с ней виртуальных предметов. Все права на игру и интеллектуальную собственность 
                принадлежат Valve Corporation.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Регистрация и аутентификация</h2>
              <p className="text-[#8b949e] leading-relaxed">
                4.1. Для совершения покупок на Сайте Покупателю необходимо авторизоваться 
                через свою учетную запись Steam.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                4.2. Покупатель обязан предоставить достоверную информацию при регистрации 
                и поддерживать её в актуальном состоянии.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                4.3. Покупатель несет полную ответственность за сохранность данных своей 
                учетной записи Steam и за все действия, совершенные с использованием его учетной записи.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                4.4. Для получения приобретенных предметов Покупатель обязан указать действующий 
                Steam Trade URL в личном кабинете.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Цена и порядок оплаты</h2>
              <p className="text-[#8b949e] leading-relaxed">
                5.1. Цена на цифровые товары указывается на Сайте в российских рублях (₽) 
                и включает все налоги и сборы.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                5.2. Продавец вправе в любое время изменять цены на товары без предварительного уведомления.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                5.3. Оплата производится следующими способами:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li>Банковские карты (Visa, Mastercard, МИР)</li>
                <li>Система быстрых платежей (СБП)</li>
                <li>Электронные кошельки</li>
                <li>Криптовалюта (при наличии соответствующей опции)</li>
              </ul>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                5.4. Оплата считается совершенной с момента зачисления денежных средств 
                на расчетный счет Продавца.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Порядок передачи товара</h2>
              <p className="text-[#8b949e] leading-relaxed">
                6.1. Передача цифрового товара осуществляется путем отправки торгового предложения 
                (trade offer) на Trade URL Покупателя в системе Steam.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                6.2. Срок доставки — до 24 часов с момента подтверждения оплаты. 
                Обычно передача осуществляется в течение нескольких минут.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                6.3. Покупатель обязан принять торговое предложение в системе Steam в течение 24 часов. 
                По истечении этого срока торговое предложение автоматически отменяется.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                6.4. При отмене торгового предложения по вине Покупателя (непринятие в течение 24 часов, 
                невозможность доставки по указанному Trade URL), Продавец возвращает денежные средства 
                на баланс аккаунта Покупателя за вычетом комиссии платежной системы (до 10%).
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                6.5. Для получения предметов Покупатель должен иметь:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li>Действующую учетную запись Steam без ограничений на торговлю</li>
                <li>Включенный Steam Guard</li>
                <li>Открытый инвентарь в настройках приватности Steam</li>
                <li>Действующий Trade URL</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Права и обязанности сторон</h2>
              <p className="text-[#8b949e] leading-relaxed font-semibold">7.1. Продавец обязуется:</p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2 mt-2">
                <li>Передать Покупателю оплаченный цифровой товар в надлежащем качестве</li>
                <li>Обеспечить возможность получения товара в течение 24 часов</li>
                <li>Предоставить достоверную информацию о товарах</li>
                <li>Соблюдать конфиденциальность персональных данных Покупателя</li>
              </ul>
              
              <p className="text-[#8b949e] leading-relaxed font-semibold mt-4">7.2. Покупатель обязуется:</p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2 mt-2">
                <li>Предоставить достоверную информацию при регистрации</li>
                <li>Своевременно оплатить выбранный товар</li>
                <li>Принять торговое предложение в системе Steam в течение 24 часов</li>
                <li>Соблюдать правила использования Сайта и условия оферты</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Возврат и отмена</h2>
              <p className="text-[#8b949e] leading-relaxed">
                8.1. В соответствии с законодательством, цифровой товар надлежащего качества 
                не подлежит возврату после его передачи Покупателю.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                8.2. В случае невозможности передачи товара по вине Продавца, Покупателю 
                возвращается полная стоимость товара на баланс аккаунта или платежное средство.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                8.3. Если приобретенный товар не соответствует описанию (например, неправильное качество wear), 
                Покупатель вправе требовать замены или возврата средств в течение 14 дней.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Ответственность сторон</h2>
              <p className="text-[#8b949e] leading-relaxed">
                9.1. Продавец не несет ответственности за невозможность использования товара 
                в случае ограничения или блокировки учетной записи Steam Покупателем со стороны Valve Corporation.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                9.2. Продавец не гарантирует бесперебойную работу Сайта и не несет ответственности 
                за временные технические неполадки.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                9.3. Покупатель несет полную ответственность за достоверность предоставленных данных 
                и соблюдение требований Steam для получения товаров.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                9.4. Стороны освобождаются от ответственности за частичное или полное неисполнение 
                обязательств по настоящей оферте, если такое неисполнение явилось следствием 
                обстоятельств непреодолимой силы.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">10. Разрешение споров</h2>
              <p className="text-[#8b949e] leading-relaxed">
                10.1. Все споры и разногласия решаются путем переговоров между сторонами.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                10.2. В случае невозможности достижения соглашения спор подлежит рассмотрению 
                в суде по месту регистрации Продавца в соответствии с действующим законодательством.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">11. Заключительные положения</h2>
              <p className="text-[#8b949e] leading-relaxed">
                11.1. Настоящая оферта регулируется законодательством страны регистрации Продавца 
                и международными договорами.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                11.2. Признание отдельных положений оферты недействительными не влечет 
                недействительности всей оферты.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                11.3. Все вопросы, не урегулированные настоящей офертой, решаются 
                в соответствии с действующим законодательством.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">12. Контактная информация</h2>
              <div className="bg-[#0d1117] rounded-lg p-4 space-y-3">
                <div className="flex items-center gap-3 text-[#8b949e]">
                  <Scale className="w-5 h-5 text-[#ff6b00]" />
                  <span className="text-[#c9d1d9] font-semibold">MEGA PANDA, LLC</span>
                </div>
                <div className="flex items-center gap-3 text-[#8b949e]">
                  <FileText className="w-5 h-5 text-[#ff6b00]" />
                  <span>NCR: 0000999047</span>
                </div>
                <div className="flex items-start gap-3 text-[#8b949e]">
                  <MapPin className="w-5 h-5 text-[#ff6b00] mt-0.5" />
                  <span>UL. BOHATERÓW MONTE CASSINO 39-14<br />PL-81-767, SOPOT, POLAND</span>
                </div>
                <div className="flex items-center gap-3 text-[#8b949e]">
                  <Mail className="w-5 h-5 text-[#ff6b00]" />
                  <span>site@xpanda.team</span>
                </div>
              </div>
            </section>

            <div className="border-t border-[#30363d] pt-6 mt-6">
              <p className="text-[#6e7681] text-sm">
                Документ вступил в силу: {new Date().toLocaleDateString('ru-RU')}<br />
                Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
